import { render, staticRenderFns } from "./BankAndPensionsTab.vue?vue&type=template&id=16cdce36&scoped=true"
import script from "./BankAndPensionsTab.vue?vue&type=script&lang=js"
export * from "./BankAndPensionsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cdce36",
  null
  
)

export default component.exports